/* eslint-disable no-unused-vars */
import { useCallback, useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'config';

export const useFacade = (arrayFromServer) => {
  const navigate = useNavigate();
  const [itemsToSave, setItemsToSave] = useState([]);
  const [sortConfig, setSortConfig] = useState(() => null);

  useEffect(() => {
    if (
      arrayFromServer !== null &&
      JSON.stringify(arrayFromServer) !== JSON.stringify(itemsToSave)
    ) {
      setItemsToSave(arrayFromServer);
    }
  }, [arrayFromServer]);

  const sortedItems = useMemo(() => {
    let sortableItems = structuredClone(itemsToSave);
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [sortConfig, itemsToSave]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = useCallback(
    (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    },
    [sortConfig],
  );

  const redirectAction = useCallback(() => {
    const link = routes.list.find((route) => route.id === 'campaign').url;
    navigate(link);
  }, []);

  return { items: sortedItems, requestSort, getClassNamesFor, redirectAction };
};
